import  { useRef,  useState } from 'react';
import './CharFadeText.css';

const CharFadeText = ({ text = "", disabled }) => {
  const shimmerRef = useRef(null);
  const [animationRunning, ] = useState(true);

  // useEffect(() => {
  //   const timeout = setInterval(() => {
  //     setAnimationRunning((prev) => !prev);
  //   }, 2500);

  //   return () => clearInterval(timeout);
  // }, []);

  return (
    <span 
      ref={shimmerRef} 
      className={`${(!disabled && animationRunning) ? 'char-shimmer' : ''} ${disabled ? 'disabled' : ''}`}
    >
      {text}
    </span>
  );
};

export default CharFadeText;
